import { Injectable, inject } from '@angular/core';
import { Broker } from '@clubhub/models';
import { ClubHubDataService } from '@shared/services/clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class BrokerService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  public broker: Broker | undefined;

  public getBrokers(agencyNumber: number, frnNumber: number, email: string) {
    return this.clubHubDataService.post<Broker[]>('Broker/GetBrokers', { agencyNumber: agencyNumber, frnNumber: frnNumber, email: email === '' ? undefined : email.trim() });
  }

  public getBrokerIgniteAccessRoute(broker?: Broker) {
    if (!broker?.userId) {
      return 'N/A';
    }

    // isSsoUser should override any user activity timestamp types
    if (broker.userIsSsoUser) {
      const externalClient = broker.userExternalClientId ? ` - ${broker.userExternalClientId}` : '';
      return `SSO${externalClient}`;
    }

    const res: string[] = [];

    // isClubHubUser and isDirectUser are based on user activity timestamps
    if (broker.userIsClubHubUser) {
      res.push('ClubHub');
    }

    if (broker.userIsDirectUser) {
      res.push('Direct');
    }

    // If user is not ClubHub or Direct based on user activity default to ClubHub
    if (res.length === 0) {
      return 'ClubHub';
    }

    return res.join('/');
  }
}
